// base class used to impose the functions available on derived Events
define('SageDotCom/DataLayer/Events/eventBase',[
    "jquery",
    "SageDotCom/Utility/sanitizer",
    "SageDotCom/DataLayer/tealium",
    "SageDotCom/PolyFills/arrayFind",
    "SageDotCom/PolyFills/hasAttribute"
],
    function ($, sanitizer, analytics) {
    function EventBase() {
        this.name = "generic_event";

        this.getName = function () {
            return this.name;
        }

        this.getLocation = function (scope) {
            var location = $(scope).closest("header").length ? "header" : $(scope).closest("footer").length ? "footer" : "body";

            if (location === "body") {
                var parent = $(scope).parent().closest("[id]");


                var component = !parent.attr("class") ? null : parent.attr("class").split(" ").find(function (value) {
                    return /^score/.test(value);
                });

                if (component) {
                    location += " > " + component.replace(/score/i, "").replace(/\-/gi, " ").trim();
                }

            }

            return location;
        }

        this.getId = function (scope) {

            // Check if the scope itself has an id
            var scopeId = $(scope).attr("id");
            if (scopeId && scopeId !== "") {
                return scopeId;
            }

            var elem = $(scope).closest("[id]");

            if (elem) {
                return elem.attr("id");
            }

            return "";
        }

        this.getLanguage = function () {
            return document.documentElement.lang;
        }

        this.cleanseString = function(str) {
            var retVal = str;

            if (retVal) {
                retVal = sanitizer.stripHtml(retVal.trim());
                retVal = retVal.replace(/\n/g, " "); // newline characters
                retVal = retVal.replace(/ +(?= )/g, ""); // remove multiple spaces
            }

            return retVal;
        }

        this.stripHtml = function (str) {
            var retVal = str;

            if (retVal) {
                retVal = sanitizer.stripHtml(retVal);
            }

            return retVal;
        }
    }

    EventBase.Name = "generic_event";

    EventBase.prototype.GenerateEventMetadata = function(scope) {
        console.log("GenerateEventMetadata called from eventBase");
        return {};
    }

    // Each derived event should fill in this.props in order to trigger tealium event
    EventBase.prototype.trigger = function () {
        analytics.event(this.props);
    }

    return EventBase;
});
